import { Construction } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import type { CustomerConfig } from '@/entities/customer-config';
import { useMe } from '@/hooks/use-me';
import { FeatureFlag } from '@/types/feature-flag';

export type AlertsSidebarInternalIconProps = {
  featureFlag: keyof CustomerConfig['featureFlags'];
};

export function AlertsSidebarInternalIcon({
  featureFlag,
}: AlertsSidebarInternalIconProps) {
  const me = useMe();

  // Show this icon only to internal users
  if (!me.isInternal) {
    return null;
  }

  // Hide this icon for demo_bess (as we use internal feature to demo)
  if (me.config.id === '49') {
    return null;
  }

  const isInternal =
    me.config.featureFlags[featureFlag] === FeatureFlag.INTERNAL;

  // Show this icon only if the feature is internal
  if (!isInternal) {
    return null;
  }

  return (
    <div className="absolute bottom-1 right-0">
      <div className="size-3">
        <Tooltip
          delay
          position="right"
          content={<p>INTERNAL - not yet available for {me.tenant}</p>}
        >
          <Construction className="size-full text-gray-400" />
        </Tooltip>
      </div>
    </div>
  );
}
